import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_cashbook_recon_config_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  cashbook_guid: fromDatatype.GuidDataFieldInterface;
  config_code: fromDatatype.VarcharDatatypeInterface;
  config_name: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  algorithm_code: fromDatatype.VarcharDatatypeInterface;
  score: fromDatatype.NumericDatatypeInterface
  config_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_mst_cashbook_recon_config_RowClass
  implements bl_fi_mst_cashbook_recon_config_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    config_code: fromDatatype.VarcharDatatypeInterface;
    config_name: fromDatatype.VarcharDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    algorithm_code: fromDatatype.VarcharDatatypeInterface;
    score: fromDatatype.NumericDatatypeInterface
    config_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}
